module.exports = " <div class=\"wrapper wrapper-content animated fadeInUp\"> <div class=ibox> <div class=ibox-content> <div style=text-align:center;margin-top:200px> <h3>尊敬的用户，您好！</h3> <p class=text-center style=\"margin:20px 0\">欢迎使用E税云，为了不影响您的正常使用，请您导入License授权！</p> <label for=license-upload-btn class=\"btn btn-primary btn-lg\">导入License</label> <button id=license-upload-btn style=display:none class=\"btn btn-primary btn-lg\" type=file ngf-select=\"uploadFiles($file, $invalidFiles)\" accept=* ngf-max-height=1000 ngf-max-size=1MB> 导入License</button> </div> </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/main/license/view/license.html
// module id = 6MsZ
// module chunks = 0